// import MessageBox from '@/components/messageBox/src/local'
/**
 * axios统一错误处理主要针对HTTP状态码错误
 * @param {Object} err
 */
import store from '../store'
import { Message, MessageBox } from 'element-ui';
import router from '../router'
import { escapeZtE } from '../utils/common'
export function errorHandle(err) {
  console.log(err.response, err.message)
  // 判断服务器是否响应了
  if (err.response) {
    switch (err.response.status) {
      // 用户无权限访问接口
      case 401:
        netError('Please log in first~')
        break
      // 请求的资源不存在
      case 404:
        // 处理404
        netError('Network disconnection, please check your network connection ~')
        break
      // 服务器500错误
      case 500:
        netError('Server exception, please try again later')
        break
    }
  } else if (
    err.code === 'ECONNABORTED' ||
    err.message === 'Network Error' ||
    err.message.includes('timeout') ||
    !window.navigator.onLine
  ) {
    // 处理超时和断网
    // alert('Network disconnection, please check your network connection ~')
    netError();
    // MessageBox.$alert('网络已断开，请查看你的网络连接~')
  } else {
    // 进行其他处理
    console.log("err", err)
    Message({
      type: "error",
      message: err.message
    })
  }
}
/**
 * axios统一错误处理主要针对业务异常
 * @param {Object} err
 */
export function businessErrorHandle(data) {
  // console.log(data)
  switch (data.code) {
    case "1001":
      //无权 todo 重新登录提示
      bisErrorMB();
      store.dispatch('user/logout')
      // MessageBox.confirm('Your login information is invalid', 'Invalid login information detected', {
      //   confirmButtonText: 'Login page',
      //   cancelButtonText: 'Later',
      //   type: 'warning'
      // }).then(() => {
      //   router.push({ name: "Login/Register" })
      // }).catch(() => {
      //   location.reload();
      // });
      // console.log(data);
      break;
    case "1002":
      //业务异常
      // console.log(data);
      bisErrorM(data.msg)
      // Message({
      //   type: "error",
      //   message: escapeZtE(data.msg)
      // })
      break;
    case "1":
      bisErrorM(data.msg)

      // Message({
      //   type: "error",
      //   message: escapeZtE(data.msg)
      // })
      break;
  }
}
// export const businessErrorHandleThrottle = (data) => {
//   _.throttle(
//     businessErrorHandle(data), 2000, { leading: true, trailing: false }
//   )
// }
const netError = _.debounce(
  (msg) => { Message.error(msg ? msg : 'Network disconnection, please check your network connection ~') },
  2000,
  { leading: true, trailing: false }
)
const bisErrorMB = _.debounce((msg) => {
  MessageBox.confirm('Your login information is invalid', 'Invalid login information detected', {
    confirmButtonText: 'Login page',
    cancelButtonText: 'Later',
    type: 'warning'
  }).then(() => {
    router.push({ name: "Login/Register" })
  }).catch(() => {
    location.reload();
  });
}, 2000, { leading: true, trailing: false })
const bisErrorM = _.debounce((msg) => {
  Message({
    type: "error",
    message: escapeZtE(msg)
  })
}, 2000, { leading: true, trailing: false })
export const businessErrorHandleThrottle = _.debounce((data) => {
  businessErrorHandle(data), 2000, { leading: true, trailing: false }
})
// export default {
//   errorHandle,
//   businessErrorHandle,
// }



// WEBPACK FOOTER //
// ./src/utils/errorHandle.js